import React from "react";

const TopBar = () => {
  return (
    <div className="top-bar top-bar-sticky">
      <div className="container">
        <div className="row">
          {/* Left Side - Contact Info */}
          <div className="col-6 col-xl-9 col-xxl-9 col-sm-6 col-md-6 col-lg-6">
            <a href="mailto:info@itdoseinfo.com" title="Email us">
              <span className="mr-2 bx bx-envelope"></span>
              <span className="d-none d-md-inline-block">
                info@itdoseinfo.com
              </span>
            </a>

            <span className="mx-md-3 d-inline-block"></span>

            <a
              href="https://wa.me/919654482139?text=Hello!"
              target="_blank"
              rel="noopener noreferrer"
              title="WhatsApp Us"
            >
              <span className="mr-1 bx bxl-whatsapp"></span>
              <span className="d-none d-md-inline-block">+91 96544 82139</span>
            </a>

            <span className="mx-md-2 d-inline-block"></span>

            <a href="tel:+91-120-3200792,+911203200791" title="Call us">
              <span className="mr-2 bx bx-phone"></span>
              <span className="d-none d-md-inline-block">
                +91-120-3200792 , +911203200791
              </span>
            </a>

            <span className="mx-md-2 d-inline-block"></span>

            <a href="/contact-us" title="Visit us">
              <span className="mr-2 bx bx-map"></span>
              <span className="d-none d-md-inline-block">
                Noida, Uttar Pradesh-201301
              </span>
            </a>
          </div>

          {/* Right Side - Social Icons */}
          <div className="col-6 col-xl-3 col-xxl-3 col-sm-6 col-md-6 col-lg-6">
            <div className="float-right">
              <a
                href="https://twitter.com/itdoseinfo"
                target="_blank"
                rel="noopener noreferrer"
                title="Twitter"
              >
                <span className="mr-1 bx bxl-twitter"></span>
              </a>

              <span className="mx-md-1 d-inline-block"></span>

              <a
                href="https://www.facebook.com/itdoseinfo/"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <span className="mr-1 bx bxl-facebook"></span>
              </a>

              <span className="mx-md-1 d-inline-block"></span>

              <a
                href="https://www.linkedin.com/company/itdose"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <span className="mr-1 bx bxl-linkedin"></span>
              </a>

              <span className="mx-md-1 d-inline-block"></span>

              <a
                href="https://www.instagram.com/itdoseinfosystems/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <span className="mr-1 bx bxl-instagram"></span>
              </a>

              <span className="mx-md-1 d-inline-block"></span>

              <a
                href="https://www.youtube.com/channel/UCUltjTYne7tfPQsiSSQKjMQ"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube"
              >
                <span className="mr-1 bx bxl-youtube"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
